import { WidgetStrategy } from 'widgets/WidgetRegistry';
import SupportVisualisation from 'widgets/supportVisualisation/SupportVisualisation';
import {
    Button,
    DropdownTooltipText,
} from '@instinet-analytics/semantic-ui-components';
import React from 'react';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { useSupportVisualisationPopupParent } from 'widgets/supportVisualisation/SupportVisualisationPopup/SupportVisualisationPopupService';

export const supportVisualisationDescription: DropdownTooltipText = {
    body: <SupportVisualisationDescription />,
    previews: [],
};

export const supportVisualisationWidgetStrategy: WidgetStrategy = {
    title: 'Support Visualisation',
    supportedHosts: ['layout'],
    reactComponentType: SupportVisualisation,
    description: supportVisualisationDescription,
    categories: [WidgetCategory.TOP],
    requiredAuthorities: ['indigo.enableIndigo2Support'],
    portfolioSelectionRequirements: PortfolioSelectionRequirements.None,
};

function SupportVisualisationDescription() {
    const popupParent = useSupportVisualisationPopupParent();

    const onClickPopup = () => {
        popupParent!.openPopup();
    };
    return (
        <>
            <div>Tool for visualisation of support state file</div>
            {popupParent && (
                <Button onClick={onClickPopup} primary className="open-popup">
                    Open Popup
                </Button>
            )}
        </>
    );
}
